import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';

/** pageConfig 中函数字段可能是原生函数或 JSON 序列化后的字符串 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TConfigFunction<T extends (...args: any[]) => any> = T | string;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function resolveConfigFunction<T extends (...args: any[]) => any>(
  fn: TConfigFunction<T> | undefined,
): T | undefined {
  if (!fn) return undefined;
  if (typeof fn === 'function') return fn;
  if (typeof fn === 'string') {
    const resolved = stringToFunction(fn);
    return typeof resolved === 'function' ? (resolved as T) : undefined;
  }
  return undefined;
}
